import React, { useState } from 'react';
import { useUserContext } from '@nexus/fff-utilities';

import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import Layout from '../../components/Layout';
import MainBanner from './MainBanner';
import OptionButtons from '../TrialUpgrade/OptionButtons';
import PerksList from './PerksList';
import Coupons from './Coupons';
import { Plans } from '../constants';
import './styles.scss';
import useLaunchDarkly from '../../hooks/useLaunchDarkly';
import NotFoundError from '../NotFoundError';

const Reactivate = ({ flags, ldClient }) => {
  const [selected, setSelected] = useState(Plans.SEASONAL);
  const handleChange = (membership) => setSelected(membership);
  const { userInfo } = useUserContext();
  const handleClick = () => null;
  useLaunchDarkly(ldClient, userInfo);

  if (flags && flags.newReactivate === false) {
    return <NotFoundError />;
  }

  if (flags && flags.newReactivate) {
    return (
      <Layout
        isLoading={false}
        redirectIfNoAuth={false}
      >
        <MainBanner />
        <div className="buttons-container">
          <OptionButtons
            handleChange={handleChange}
            selected={selected}
          />
        </div>
        <div className="reactivate-list-container">
          <PerksList membership={selected} />
        </div>
        <div className="body-container">
          <Coupons membership={selected} />
          <p className="reactivate-notice">
            By clicking “Reactivate Me”, you authorize us to reactivate your subscription and charge $71.99 USD
            (consisting of $49.99 membership fee,
            $10 shipping fee and Value-Added Tax), minus any applicable discount, to the payment method on file.
            Foreign exchange or transaction fees may apply for non-US customers.
            You are also agreeing to abide by out Terms of Use and Sale and our Membership Terms.
            Subscription will auto-renew each season. Cancel at any time.
          </p>
          <div className="reactivate-action text-center">
            <button
              type="button"
              className="btn btn-lg btn-cta"
              onClick={() => handleClick()}
            >
              REACTIVATE ME
            </button>
          </div>
        </div>
      </Layout>
    );
  }
  return null;
};

export default withLDConsumer()(Reactivate);
